const BOOSTED_MULTIPLIER = 0.8;
const BOOSTED_ROUNDING = 2;

export const calculateBoostedOdds = (coeficient: number) => {
  return ((coeficient - 1) * BOOSTED_MULTIPLIER + 1).toFixed(BOOSTED_ROUNDING);
};
